import { registerAdapter } from './sync-adapter.js';
import { nullAdapter } from './null-adapter.js';
import { fileSystemAdapter } from './file-system-adapter.js';

registerAdapter(nullAdapter);
registerAdapter(fileSystemAdapter);

export { listAdapters, getAdapter } from './sync-adapter.js';
